"use client";

export const extractAudioSegment = async ({
  audioBuffer,
  startTimeSeconds,
  endTimeSeconds,
}: {
  audioBuffer: AudioBuffer;
  startTimeSeconds: number;
  endTimeSeconds: number;
}): Promise<AudioBuffer> => {
  const sampleRate = audioBuffer.sampleRate;
  const numberOfChannels = audioBuffer.numberOfChannels;

  const startSample = Math.floor(startTimeSeconds * sampleRate);
  const endSample = Math.floor(endTimeSeconds * sampleRate);
  const segmentLength = endSample - startSample;

  const audioContext = new AudioContext();
  try {
    const newBuffer = audioContext.createBuffer(
      numberOfChannels,
      segmentLength,
      sampleRate
    );

    for (let channel = 0; channel < numberOfChannels; channel++) {
      const sourceData = audioBuffer.getChannelData(channel);
      const targetData = newBuffer.getChannelData(channel);

      for (let i = 0; i < segmentLength; i++) {
        targetData[i] = sourceData[startSample + i];
      }
    }

    return newBuffer;
  } finally {
    await audioContext.close();
  }
};
